module.exports = __webpack_public_path__ + "img/forum3.31b58ba9.jpg";